module.exports = __webpack_public_path__ + "img/zhifubao.9e811994.png";